<template>
	<notifications
		:position="position"
		:group="group"
		:width="width"
		:duration="duration"
		:max="max"
		:closeOnClick="closeOnClick"
		:style="style"
	>
		<template slot="body" slot-scope="props">
			<div class="notification" :class="props.item.type">
				<div class="notification-main" :class="props.item.type">
					<div class="notification-icon">
						<t-timpex-icon
							:icon="getIcon(props.item.type)"
							type="bp"
							size="sm"
							color="white"
						/>
					</div>
					<div class="notification-inner">
						<!-- if there is no title, use text instead -->
						{{ props.item.title ? props.item.title : props.item.text }}
					</div>
					<t-icon-button
						icon="cross"
						iconSize="x-small"
						type="bp"
						size="small"
						appearance="transparent"
						class="close"
						@click="props.close"
					/>
				</div>
				<div class="notification-description">
					{{ props.item.title ? props.item.text : '' }}
				</div>
			</div>
		</template>
	</notifications>
</template>


<script>
export default {
	name: 'TNotification',
	props: {
		position: {
			type: String,
			default: 'top center'
		},
		group: String,
		width: {
			type: [ Number, String ],
			default: '30%'
		},
		duration: {
			type: Number,
			default: 3000
		},
		max: Number,
		closeOnClick: Boolean
	},
	computed: {
		style() {
			return this.position.includes('top') ? 'top: 34px;' : '';
		}
	},
	methods: {
		getIcon(notificationType) {
			switch (notificationType) {
			case 'success':
				return 'tick';
			case 'error':
				return 'cross';
			case 'warning':
				return 'error';
			default:
				return 'plus';
			}
		}
	}
};
</script>


<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';
@import '~@/components/evergreen/scss/text';

@mixin dot($color, $size) {
	display: flex;
	height: #{$size}px;
	width: #{$size}px;
	background-color: $color;
	border-radius: 100%;
}

.notification {
	position: relative;
	overflow: hidden;
	margin: 2px 8px 12px;
	padding: 12px;
	padding-left: 16px;
	border-radius: 5px;
	box-shadow: rgba(67, 90, 111, 0.3) 0px 0px 2px, rgba(67, 90, 111, 0.47) 0px 8px 10px -4px;
	background-color: #ffffff;
	display: flex;
	flex-direction: column;
	&.success {
		border-left: 4px solid get-color($green);
	}

	&.error {
		border-left: 4px solid get-color($red);
	}

	&.warning {
		border-left: 4px solid get-color($yellow);
	}
}

.notification-main {
	display: flex;
	align-items: center;
	justify-content: space-between;
	min-height: 24px;
	width: width;

	.notification-icon {
		align-items: center;
		padding: 2px;
		margin-right: 10px;
	}

	.notification-inner {
		@extend %text-default;
		@extend %font-families-display;
		width: 240px;
		min-height: 20px;
		font-weight: 600;
		font-stretch: normal;
		line-height: 1.43;
		color: #234361;
		flex: 1;
	}

	.close {
		flex-shrink: 0;
	}

	&.success {
		.notification-icon {
			@include dot(get-color($green), 14);
		}
	}

	&.error {
		.notification-icon {
			@include dot(get-color($red), 14);
		}
	}

	&.warning {
		.notification-icon {
			@include dot(get-color($yellow), 14);
		}
	}
}

.notification-description {
	@extend %text-small;
	@extend %font-families-display;
	margin-left: 24px;
	color: get-color($text, 'muted');
}
</style>
